import Axios from "axios";

import { apiUrl, serializeObjToGetStr } from "../../constants";

const inventoryReportBaseUrl = `${apiUrl}/inventoryreport`;
const config = {
    headers: { "Content-Type": "application/json-patch+json" }
};

export const inventoryReportApi = {
  getAll: (request) => {
    const query = serializeObjToGetStr(request);
    return Axios.get(`${inventoryReportBaseUrl}?${query}`);
  },
};
